export const displayFavoriteAndRecentAddressesSelector = ({displayFavoriteAndRecentAddresses}) => displayFavoriteAndRecentAddresses